/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Task_ClientInputs */

const en_dashboard_task_client = /** @type {(inputs: Dashboard_Task_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client`)
};

const pt_br2_dashboard_task_client = /** @type {(inputs: Dashboard_Task_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente`)
};

/**
* | output |
* | --- |
* | "Client" |
*
* @param {Dashboard_Task_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_task_client = /** @type {((inputs?: Dashboard_Task_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Task_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_task_client(inputs)
	return pt_br2_dashboard_task_client(inputs)
});